export default __webpack_public_path__ + "static/ministerio-economia-y-competitividad-db46915e22b97f5a67fc7e341834ecc6.png";